import Practice from "app/models/practice"
import { Action, Types } from "./practices.actions"

export type PracticesState = {
  data: Practice[] | undefined
  errors: {}
  loading: boolean
}

const initialState: PracticesState = {
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PracticesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
